export const uploadImageToS3 = (image, presignedUrl) =>
  fetch(presignedUrl, {
    method: "PUT",
    body: image,
  }).then((res) => res.url.substring(0, res.url.indexOf("?")));
